var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.error)?_c('div',{staticClass:"field-error"},_vm._l((_vm.error),function(value,index){return _c('div',{key:index,staticClass:"error"},[_vm._v(_vm._s(value))])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }